module.exports = __webpack_public_path__ + "static/TrainingObjective_1-718856e800b018d2c412aacc5263ea8d.png";